<template>
    <div class="modal fade" id="openConditionModal" tabindex="-1" aria-labelledby="openConditionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <form v-if="selectedCondition" class="modal-content" @submit.prevent="handleSubmit">
                <div class="modal-header text-bg-info">
                    <h5 class="modal-title" id="openConditionModalLabel">{{ $t('conditionModal.title') }}</h5>
                    <button type="button" class="btn-close text-light" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body px-0">
                    <div id="condition-container" class="row p-2 p-md-3">
                        <div class="col-12">
                            <h4 class="text-info mt-0">{{ $t('conditionModal.conditionType') }}</h4>
                            <select v-model="selectedCondition.condition_type" class="form-select mt-2 border-info" required>
                                <option value="" disabled>{{ $t('conditionModal.selectCondition') }}</option>
                                <option value="event">{{ $t('conditionModal.types.event') }}</option>
                                <option value="input">{{ $t('conditionModal.types.input') }}</option>
                                <option value="date">{{ $t('conditionModal.types.date') }}</option>
                                <option value="time">{{ $t('conditionModal.types.time') }}</option>
                                <option value="day_of_week">{{ $t('conditionModal.types.dayOfWeek') }}</option>
                                <option v-if="externalAlarms.length > 0" value="external_intrusion_state">{{ $t('conditionModal.types.externalIntrusion') }}</option>
                            </select>
                        </div>

                        <!-- Condition Evènement -->
                        <div v-if="selectedCondition.condition_type === 'event'" class="mt-2">
                            <div class="col-12">
                                <label for="event" class="form-label">{{ $t('conditionModal.event') }}</label>
                                <multiselect
                                    id="event"
                                    v-model="selected_events"
                                    track-by="id"
                                    label="label"
                                    :options="events"
                                    :multiple="true"
                                    :placeholder="$t('conditionModal.selectEvents')"
                                    :selectLabel="$t('multiselect.selectLabel')"
                                    :deselectLabel="$t('multiselect.deselectLabel')"
                                    :selectedLabel="$t('multiselect.selectedLabel')"
                                    :clear-on-select="true"
                                    required>
                                </multiselect>
                                <div class="d-flex justify-content-between align-items-center bg-primary-lighten rounded py-1 px-2 mt-2">
                                    <label class="form-check-label flex-grow-1 me-2" for="reader-filter">{{ $t('conditionModal.filterByReaders') }}</label>
                                    <input type="checkbox" id="reader-filter" data-switch="bool" v-model="selectedCondition.events.has_readers" />
                                    <label for="reader-filter" :data-on-label="$t('common.yes')" :data-off-label="$t('common.no')"></label>
                                </div>
                                <multiselect v-if="selectedCondition.events.has_readers"
                                    v-model="selected_readers"
                                    track-by="position"
                                    label="label"
                                    :options="readers"
                                    :multiple="true"
                                    class="mt-2"
                                    :placeholder="$t('conditionModal.selectReaders')"
                                    :selectLabel="$t('multiselect.selectLabel')"
                                    :deselectLabel="$t('multiselect.deselectLabel')"
                                    :selectedLabel="$t('multiselect.selectedLabel')"
                                    :clear-on-select="true"
                                    required>
                                </multiselect>
                                <div class="d-flex justify-content-between align-items-center bg-primary-lighten rounded py-1 px-2 mt-2">
                                    <label class="form-check-label flex-grow-1 me-2" for="group-filter">{{ $t('conditionModal.filterByGroups') }}</label>
                                    <input type="checkbox" id="group-filter" data-switch="bool" v-model="selectedCondition.events.has_groups" />
                                    <label for="group-filter" :data-on-label="$t('common.yes')" :data-off-label="$t('common.no')"></label>
                                </div>
                                <multiselect v-if="selectedCondition.events.has_groups"
                                    v-model="selected_groups"
                                    track-by="id"
                                    label="name"
                                    :options="groups"
                                    :multiple="true"
                                    class="mt-2"
                                    :placeholder="$t('conditionModal.selectGroups')"
                                    :selectLabel="$t('multiselect.selectLabel')"
                                    :deselectLabel="$t('multiselect.deselectLabel')"
                                    :selectedLabel="$t('multiselect.selectedLabel')"
                                    :clear-on-select="true"
                                    required>
                                </multiselect>
                                <div class="d-flex justify-content-between align-items-center bg-primary-lighten rounded py-1 px-2 mt-2">
                                    <label class="form-check-label flex-grow-1 me-2" for="identifier-filter">{{ $t('conditionModal.filterByIdentifiers') }}</label>
                                    <input type="checkbox" id="identifier-filter" data-switch="bool" v-model="selectedCondition.events.has_identifiers" />
                                    <label for="identifier-filter" :data-on-label="$t('common.yes')" :data-off-label="$t('common.no')"></label>
                                </div>
                                <multiselect v-if="selectedCondition.events.has_identifiers"
                                    v-model="selectedCondition.events.identifiers"
                                    :options="[]"
                                    class="mt-2"
                                    :multiple="true"
                                    :placeholder="$t('conditionModal.enterIdentifier')"
                                    :clear-on-select="true"
                                    :taggable="true"
                                    :showNoOptions="false"
                                    @tag="addIdentifierFilter($event)"
                                    :tagPlaceholder="$t('conditionModal.identifierTagPlaceholder')"
                                    required>
                                </multiselect>
                            </div>
                        </div>

                        <!-- Condition Etat d'une entrée -->
                        <div v-if="selectedCondition.condition_type === 'input'" class="mt-2">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-2">
                                    <label for="input" class="form-label">{{ $t('conditionModal.input') }}</label>
                                    <select id="input" class="form-select" v-model.number="selectedCondition.input.input_number" required>
                                        <option value="" disabled>{{ $t('conditionModal.selectInput') }}</option>
                                        <option v-for="input in inputs" :key="input.intput_number" :value="input.input_number">
                                            {{ input.toString() }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-6 mb-2">
                                    <label for="input-state" class="form-label">{{ $t('conditionModal.state') }}</label>
                                    <select id="input-state" class="form-select" v-model.number="selectedCondition.input.state" required>
                                        <option value="" disabled>{{ $t('conditionModal.selectState') }}</option>
                                        <option value="1">{{ $t('conditionModal.stateActive') }}</option>
                                        <option value="0">{{ $t('conditionModal.stateInactive') }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <!-- Condition Etat d'une alarme intrusion externe -->
                        <div v-if="selectedCondition.condition_type === 'external_intrusion_state'" class="mt-2">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-2">
                                    <label for="external-alarm" class="form-label">{{ $t('conditionModal.externalAlarm') }}</label>
                                    <select id="external-alarm" class="form-select" v-model.number="selectedCondition.external_intrusion_state.id" required>
                                        <option value="" disabled>{{ $t('conditionModal.selectExternalAlarm') }}</option>
                                        <option v-for="alarm in externalAlarms" :key="alarm.id" :value="alarm.id">
                                            {{ alarm.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-6 mb-2">
                                    <label for="intrusion-state" class="form-label">{{ $t('conditionModal.state') }}</label>
                                    <select id="intrusion-state" class="form-select" v-model="selectedCondition.external_intrusion_state.state" required>
                                        <option value="" disabled>{{ $t('conditionModal.selectState') }}</option>
                                        <option value="Armed">{{ $t('conditionModal.intrusionArmed') }}</option>
                                        <option value="Disarmed">{{ $t('conditionModal.intrusionDisarmed') }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <!-- Condition Sur une date -->
                        <div v-if="selectedCondition.condition_type === 'date'" class="mt-2">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-2 position-relative">
                                    <label for="start-date" class="form-label">{{ $t('conditionModal.startDate') }}</label>
                                    <VueDatePicker id="start-date" v-model="selectedCondition.date.start" :locale="$i18n.locale === 'fr' ? 'fr-FR' : 'en-GB'" auto-apply :enable-time-picker="false" format="dd/MM/yyyy" model-type="yyyy-MM-dd" :placeholder="$t('conditionModal.datePlaceholder')" required></VueDatePicker>
                                </div>
                                <div class="col-12 col-md-6 mb-2 position-relative">
                                    <label for="end-date" class="form-label">{{ $t('conditionModal.endDate') }}</label>
                                    <VueDatePicker id="end-date" v-model="selectedCondition.date.end" :locale="$i18n.locale === 'fr' ? 'fr-FR' : 'en-GB'" auto-apply :enable-time-picker="false" format="dd/MM/yyyy" model-type="yyyy-MM-dd" :placeholder="$t('conditionModal.datePlaceholder')"></VueDatePicker>
                                </div>
                            </div>
                        </div>

                        <!-- Condition Sur une heure -->
                        <div v-if="selectedCondition.condition_type === 'time'" class="mt-2">
                            <div class="row">
                                <div class="col-12 col-md-6 mb-2 position-relative">
                                    <label for="start-time" class="form-label">{{ $t('conditionModal.startTime') }}</label>
                                    <VueDatePicker id="start-time" v-model="start_time" time-picker :select-text="$t('common.submit')" :cancel-text="$t('common.cancel')" model-type="HH:mm" :placeholder="$t('conditionModal.timePlaceholder')" required></VueDatePicker>
                                </div>
                                <div class="col-12 col-md-6 mb-2 position-relative">
                                    <label for="end-time" class="form-label">{{ $t('conditionModal.endTime') }}</label>
                                    <VueDatePicker id="end-time" v-model="end_time" time-picker :select-text="$t('common.submit')" :cancel-text="$t('common.cancel')" model-type="HH:mm" :placeholder="$t('conditionModal.timePlaceholder')"></VueDatePicker>
                                </div>
                            </div>
                        </div>

                        <!-- Condition Jour de la semaine -->
                        <div v-if="selectedCondition.condition_type === 'day_of_week'" class="mt-2">
                            <div class="col-12">
                                <label for="event" class="form-label">{{ $t('conditionModal.daysOfWeek') }}</label>
                                <multiselect
                                    id="event"
                                    v-model="selectedCondition.days_of_week"
                                    track-by="id"
                                    :options="weekDays"
                                    :multiple="true"
                                    :placeholder="$t('conditionModal.selectDays')"
                                    :selectLabel="$t('multiselect.selectLabel')"
                                    :deselectLabel="$t('multiselect.deselectLabel')"
                                    :selectedLabel="$t('multiselect.selectedLabel')"
                                    :clear-on-select="true">
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" ref="closeButton" data-bs-dismiss="modal">{{ $t('common.cancel') }}</button>
                    <span v-if="errorMessage" class="custom-error-msg">{{ errorMessage }}</span>
                    <button type="submit" class="btn btn-primary">{{ $t('common.add') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { useClientStore } from '@/stores/clientStore';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Condition from '@/models/condition'
import WeekDay from '@/models/weekDay'
import Multiselect from 'vue-multiselect';

export default {
    name: 'ConditionModal',
    components: {
        Multiselect
    },
    data() {
        return {
            weekDays: [new WeekDay('Mon'), new WeekDay('Tue'), new WeekDay('Wed'), new WeekDay('Thu'), new WeekDay('Fri'), new WeekDay('Sat'), new WeekDay('Sun'), new WeekDay('Hol')],
        };
    },
    computed: {
        events() {
            const clientStore = useClientStore();
            return clientStore.getEventTypeOptions([48,49]);
        },
        readers() {
            const clientStore = useClientStore();
            return clientStore.getReaders();
        },
        groups() {
            const clientStore = useClientStore();
            return clientStore.getAccessGroups();
        },
        inputs() {
            const clientStore = useClientStore();
            return clientStore.getInputs();
        },
        externalAlarms() {
            const clientStore = useClientStore();
            return clientStore.getExternalAlarms();
        },
    },
    setup(props, { emit }) {
        useI18n();
        const closeButton = ref(null);
        const selectedCondition = ref(null);
        const errorMessage = ref('');

        const selected_events = computed({
            get() {
                const clientStore = useClientStore();
                return clientStore.getEventTypes(selectedCondition.value.events.event_type_ids);
            },
            set(ids) {
                selectedCondition.value.events.event_type_ids = ids.map(e => e.id);
            }
        });

        const selected_readers = computed({
            get() {
                const clientStore = useClientStore();
                return clientStore.getReaders(selectedCondition.value.events.reader_positions);
            },
            set(readers) {
                selectedCondition.value.events.reader_positions = readers.map(e => e.position);
            }
        });

        const selected_groups = computed({
            get() {
                const clientStore = useClientStore();
                return clientStore.getAccessGroups(selectedCondition.value.events.groups);
            },
            set(groups) {
                selectedCondition.value.events.groups = groups.map(e => e.id);
            }
        });

        const start_time = computed({
            get() {
                return selectedCondition.value.time.startAsTime;
            },
            set(value) {
                selectedCondition.value.time.startAsTime = value;
            }
        });

        const end_time = computed({
            get() {
                return selectedCondition.value.time.endAsTime;
            },
            set(value) {
                selectedCondition.value.time.endAsTime = value;
            }
        });

        const setCondition = (condition) => {
            if(condition.id === -1) {
                selectedCondition.value = condition;
            } else {
                selectedCondition.value = Condition.constructFromObject(condition);
            }
            errorMessage.value = "";
        };

        const handleSubmit = () => {
            emit('onConditionUpdated', selectedCondition.value);
            closeButton.value.click();
        };

        const addIdentifierFilter = (newIdentifier) => {
            if(selectedCondition.value.events.identifiers.findIndex(i => i === newIdentifier) == -1) {
                selectedCondition.value.events.identifiers.push(newIdentifier);
            }
        };

        return {
            closeButton,
            selectedCondition,
            selected_events,
            handleSubmit,
            setCondition,
            errorMessage,
            start_time,
            end_time,
            selected_readers,
            selected_groups,
            addIdentifierFilter,
        }
    },
};
</script>
